import * as DropdownMenu from "zeego/dropdown-menu";
import { DropdownContent } from "~/components/dropdown/DropdownContent";
import { DropdownItem } from "~/components/dropdown/DropdownItem";
import { DropdownItemIcon } from "~/components/dropdown/DropdownItemIcon";
import { DropdownItemTitle } from "~/components/dropdown/DropdownItemTitle";

export const DropdownRoot = DropdownMenu.Root;
export const DropdownTrigger = DropdownMenu.Trigger;

export { DropdownContent, DropdownItem, DropdownItemTitle, DropdownItemIcon };
